import { util } from 'pevueglobal'
import {
  setXVtableMutations,
  XVtableSetRowStateProperty,
  XVtableGetRowStateProperty,
  XVtableGetValue
} from '../XVtableV2'
import { router } from '@/router'

// state
const state = {
  inzageTable: {
    tablesetting: {},
    tablecolumnsetting: [],
    tabledata: [],
    rowvisible: []
  },
  forminputdata: {
    profgroupsSelected: [],
    tbxName: '',
    tbxemail: '',
    tbxDateUpTo: null,
    ddlRolSelected: ''
  },
  rollen: [],
  profgroups: [],
  adminprofgroups: [],
  cblProfgroups: [],
  selectprofgroups: 0,
  datumSelected: null,
  selectedUser: 0,
  disableInsertBtn: false
}

// getters
const getters = {
  inzageTable: state => state.inzageTable,
  XVtableGetRowStateProperty: XVtableGetRowStateProperty('inzageTable'),
  XVtableGetValue: XVtableGetValue('inzageTable'),
  rollen: state => state.rollen,
  profgroups: state => state.profgroups,
  adminprofgroups: state => state.adminprofgroups,
  cblProfgroups: state => state.cblProfgroups,
  selectprofgroups: state => state.selectprofgroups,
  datumSelected: state => state.datumSelected,
  rolSelected: state => state.rolSelected,
  selectedUser: state => state.selectedUser,
  disableInsertBtn: state => state.disableInsertBtn
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [17, 23, 150, 9377, 10931, 10932, 11953, 11954, 11955, 14589, 14642, 14702, 14764, 15461]
    for (var i = 11964; i <= 11977; i++) {
      textIDs.push(i)
    }
    dispatch('gettranslations', textIDs, { root: true })
  },
  getXVtable: async ({ commit }) => {
    const xvtabledata = await util.GetXVTableDataV2('prof/PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable')
    if (xvtabledata !== null) {
      commit('setInzageTable', xvtabledata)
      commit('setXVtableColumnsettings')
      commit('setXVtablesetting')
      commit('initXVtableState', state.inzageTable)
    }
  },
  getRollenProfgroups: async ({ commit }) => {
    // Dropdown rollen en checkboxen profgroups.
    const myRollenProfgroups = await util.getDataApi('prof/PEapi_SPE015_PR_PersonAutorisedAdmin')
    commit('setRollenProfgroups', myRollenProfgroups)
  },
  getAdminProfgroups: async ({ commit }, id) => {
    // Voor ophalen profgroups van de personadmin.
    const myAdminProfgroups = await util.getDataApi('prof/PEapi_SPE015_PR_PersonAutorisedAdmin_profgroups', {
      tblPersonAutorisedAdminID: id
    })
    commit('setAdminprofgroups', myAdminProfgroups)
  },
  insertPerson: async ({ commit, rootState }, input) => {
    const output = await util.getDataApi('prof/PEapi_PersonAutorisedAdmin_insert', input)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )

      commit('redirectToOverview')
    }
  },
  updatePerson: async ({ commit, rootState, dispatch }, input) => {
    const output = await util.getDataApi('prof/PEapi_PersonAutorisedAdmin_update', input)
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'primary',
          message: rootState.translation[149]
        },
        { root: true }
      )

      dispatch('getXVtable')
    }
  },
  deletePerson: async ({ commit, rootState, dispatch }, id) => {
    const output = await util.getDataApi('prof/PEapi_PersonAutorisedAdmin_delete', {
      tblPersonAutorisedAdminID: id
    })
    if (output.status === '200') {
      commit(
        'addNotification',
        {
          groupname: 'danger',
          message: rootState.translation[15462]
        },
        { root: true }
      )
      // opnieuw ophalen, na verwijderen is het mogelijk dat rol niet meer zichtbaar is.
      dispatch('getXVtable')
      commit('setDeletePerson', id)
    }
  }
}

// mutations
const mutations = {
  ...setXVtableMutations('inzageTable'),
  XVtableSetRowStateProperty: XVtableSetRowStateProperty('inzageTable'),
  setforminputdata(state, forminputdata) {
    state.forminputdata = {
      ...state.forminputdata,
      ...forminputdata
    }
  },
  setRollenProfgroups(state, myRollenProfgroups) {
    state.rollen = myRollenProfgroups.ds.data0
    state.profgroups = myRollenProfgroups.ds.data1
    state.selectprofgroups = myRollenProfgroups.ds.data1[0].selectprofgroups
  },
  setAdminprofgroups(state, myAdminProfgroups) {
    state.adminprofgroups = myAdminProfgroups.ds.data0
  },
  setDeletePerson(state, id) {
    state.inzageTable.tabledata = state.inzageTable.tabledata.filter(rij => rij.tblPersonAutorisedAdminID !== id)
  },
  setddlRolSelected(state, value) {
    state.forminputdata.profgroupsSelected = []
    state.forminputdata.ddlRolSelected = value
    state.cblProfgroups = state.profgroups.filter(rij => rij.tblTypeAdministratorID === Number(value))
    if (state.cblProfgroups.length === 1) {
      state.forminputdata.profgroupsSelected.push(Number(state.cblProfgroups[0].value))
    }
  },
  setProfgroupInput(state) {
    if (state.selectprofgroups === 0 || state.selectprofgroups === 1) {
      state.forminputdata.profgroupsSelected = []
      state.cblProfgroups.forEach(element => {
        state.forminputdata.profgroupsSelected.push(Number(element.value))
      })
    }
  },
  setDisableInsertBtn(state, value) {
    state.disableInsertBtn = value
  },
  redirectToOverview() {
    router.push({ path: 'overview' })
  },
  setFormReset(state) {
    state.disableInsertBtn = false
    state.forminputdata = {
      profgroupsSelected: [],
      tbxName: '',
      tbxemail: '',
      tbxDateUpTo: null,
      ddlRolSelected: ''
    }
  },
  setInzageTable(state, data) {
    state.inzageTable.tabledata = data.tabledata
  },
  setXVtablesetting(state) {
    state.inzageTable.tablesetting = {
      alwaysShowDetail: null,
      tableName: 'personAutorisedAdmin',
      paging: 1,
      pagingSize: 50,
      procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable',
      sequence: 1,
      sortable: 1
    }
  },
  setXVtableColumnsettings(state) {
    state.inzageTable.tablecolumnsetting = [
      {
        columnname: '',
        helpTextID: null,
        name: 'tblPersonWijzig',
        headerTextID: 0,
        sequence: 1,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: '',
        helpTextID: null,
        name: 'tblPersonVerwijder',
        headerTextID: 0,
        sequence: 2,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: '30px',
        widthSM: '30px',
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'Text not defined',
        helpTextID: null,
        name: 'tblPersonAutorisedAdminID',
        headerTextID: null,
        sequence: 3,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: 'number',
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'Naam',
        helpTextID: null,
        name: 'tblPersonAutorisedAdminName',
        headerTextID: 11956,
        sequence: 4,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 1,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'E-mail',
        helpTextID: null,
        name: 'tblPersonAutorisedAdminEmail',
        headerTextID: 11957,
        sequence: 5,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 1,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'Datum aangemaakt',
        helpTextID: null,
        name: 'tblPersonAutorisedAdminDateCreated',
        headerTextID: 11958,
        sequence: 6,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'Toegang t/m',
        helpTextID: null,
        name: 'tblPersonAutorisedAdminDateUpTo',
        headerTextID: 11959,
        sequence: 7,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'date',
        visible: 1,
        visibleMD: 1,
        visibleSM: 1,
        visibleXS: 1,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'Rol',
        helpTextID: null,
        name: 'rol',
        headerTextID: 11960,
        sequence: 8,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'Beroepsgroep',
        helpTextID: null,
        name: 'tblProfGroup',
        headerTextID: 11961,
        sequence: 9,
        sortColumn: null,
        sortable: 1,
        sortableDefault: 0,
        type: 'string',
        visible: 0,
        visibleMD: 1,
        visibleSM: 0,
        visibleXS: 0,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: 'PEapi_SPE015_PR_PersonAutorisedAdmin_XVTable'
      },
      {
        columnname: 'tableRowState',
        helpTextID: null,
        name: 'tableRowState',
        headerTextID: null,
        sequence: 10,
        sortColumn: null,
        sortable: 0,
        sortableDefault: 0,
        type: null,
        visible: 0,
        visibleMD: null,
        visibleSM: null,
        visibleXS: null,
        widthMD: null,
        widthSM: null,
        widthXS: null,
        tableName: 'personAutorisedAdmin',
        procedure: ''
      }
    ]
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
